/**
 * containerGroup Normalizr Schema
 */

import { schema } from 'normalizr';
import moment from 'moment';

const containerGroup = new schema.Entity(
    'containerGroups',
    {},
    {
        processStrategy: (value, parent, key) => ({
            ...value,
            _printingSubmittedAt:
                value.printingSubmittedAt &&
                moment(value.printingSubmittedAt).format('DD/MM/YYYY')
        })
    }
);

export default containerGroup;
